import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../common/custompagination";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import { formateDateWithMonth } from "../../../../utils/commonfunction";
import CustomRangepicker from "../../common/rangepicker";
import { PaymentTransactionLogsList } from "../../services/paymentTransaction.services";

const FailedTransactions = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting] = useState({});
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [resetdate, setResetDate] = useState(false);
  const [globalsearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({});

  const breadcrumbs = [
    { title: t("contact-us.link_dashboard"), url: "/admin/dashboard" },
    { title: "Payment Transactions", url: "" },
  ];

  useEffect(() => {
    const getData = setTimeout(() => {
      const searchWithStatus = { ...search, status: "failed" };
      setLoader(true);
      const formData = new FormData();
      formData.append("page", params.pgno || 1);
      formData.append("per_page", itemperpage);
      formData.append("sort", JSON.stringify(sorting));
      formData.append("search", JSON.stringify(searchWithStatus));
      formData.append("global_search", globalsearch);

      PaymentTransactionLogsList(formData)
        .then((data) => {
          setDataLength(data.data.total_records);
          setList(data && data.data && data.data.list ? data?.data?.list : []);
          setPage(data && data.data && data.data.page ? data.data.page : 1);
          setLoader(false);
        })
        .catch((error) => {
          setTimeout(() => {
            setLoader(false);
          }, 500);
          console.log("error ====> ", error);
        });
    }, 300);
    return () => clearTimeout(getData);
  }, [location, sorting, search, globalsearch, itemperpage, params.pgno]);

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
  };

  const getPlatformBadge = (platform) => {
    const badges = {
      apple: "bg-success",
      android: "bg-info",
      manual: "bg-warning",
      other: "bg-secondary",
    };
    return (
      <span className={`badge ${badges[platform] || "bg-secondary"} fs-10`}>
        {platform ? platform.charAt(0).toUpperCase() + platform.slice(1) : "Other"}
      </span>
    );
  };

  const getStatusBadge = (status) => {
    const badges = {
      pending: "bg-warning",
      completed: "bg-success",
      failed: "bg-danger",
      refunded: "bg-danger",
    };
    return (
      <span className={`badge ${badges[status] || "bg-secondary"} fs-10`}>
        {status ? status.charAt(0).toUpperCase() + status.slice(1) : "Unknown"}
      </span>
    );
  };

  const getTransactionTypeBadge = (type) => {
    const badges = {
      purchase: "bg-primary",
      webhook: "bg-info",
      manual_activation: "bg-warning",
    };
    return (
      <span className={`badge ${badges[type] || "bg-secondary"} fs-10`}>
        {type ? type.replace(/_/g, " ").charAt(0).toUpperCase() + type.replace(/_/g, " ").slice(1) : "Other"}
      </span>
    );
  };

  const handleRecover = (txn) => {
    navigate(`/admin/subscription/manual-recovery?txn=${txn._id}&user_id=${txn.user_id}&product_id=${txn.product_id}&original_transaction_id=${txn.original_transaction_id || ''}&transaction_id=${txn.transaction_id || ''}&purchase_token=${txn.purchase_token || ''}&order_id=${txn.order_id || ''}&platform=${txn.platform}`);
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">Failed Transactions</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder="Search by user, transaction ID, etc."
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  Reset Filter
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                <thead>
                  <tr>
                    <th className="position-relative select_head">
                      <span>S.No</span>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>User</span>
                      </div>
                    </th>
                    <th>
                      <div className="rating_head">
                        <span>Platform</span>
                      </div>
                    </th>
                    <th>
                      <div className="rating_head">
                        <span>Type</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <span>Product</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <span>Transaction ID</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <span>Amount</span>
                      </div>
                    </th>
                    <th>
                      <div className=" text-center">
                        <span>Status</span>
                      </div>
                    </th>
                    <th className="created_head">
                      <div className="sorting_column">
                        <span>Created Date</span>
                      </div>
                    </th>
                    <th className="action_head">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={10}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                {row ? ((page - 1) * itemperpage) + i + 1 : null}
                              </td>
                              <td>{row?.user_name || "N/A"}</td>
                              <td>{getPlatformBadge(row?.platform)}</td>
                              <td>{getTransactionTypeBadge(row?.transaction_type)}</td>
                              <td>{row?.product_id || row?.plan_name || "N/A"}</td>
                              <td className="fw-bold">
                                {row?.transaction_id ||
                                  row?.original_transaction_id ||
                                  row?.order_id || "N/A"}
                              </td>
                              <td>
                                {row?.amount != null
                                  ? `${row?.currency || 'USD'} ${Number(row?.amount).toFixed(2)}`
                                  : "N/A"}
                              </td>
                              <td className="text-center">
                                {getStatusBadge(row?.status)}
                              </td>
                              <td>
                                {row.createdAt
                                  ? formateDateWithMonth(row.createdAt)
                                  : "N/A"}
                              </td>
                              <td>
                                <div className="d-flex">
                                  <button
                                    className="btn ripple btn-main-primary signbtn"
                                    onClick={() => handleRecover(row)}
                                  >
                                    Recover
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={10} className="text-center">
                            No records found
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div className="" id="example1_info" role="status" aria-live="polite">
              <b>Total Records : {datalength ? datalength : "0"}</b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[
                  {
                    name: "Payment Transactions",
                    path: "/admin/subscription/payment-transactions/list",
                  },
                ]}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FailedTransactions;
